import { Button, IconButton, InputAdornment, TextField } from "@mui/material";
import { ChangeEvent, KeyboardEvent, useState } from "react";
import Iconify from "~src/components/Iconify";

interface SearchBarProps {
  onSearch: (searchText?: string) => void;
}

export const SearchBar: React.FC<SearchBarProps> = ({ onSearch }) => {
  const [searchText, setSearchText] = useState("");
  const [showClearButton, setShowClearButton] = useState(false);

  const handleSearch = () => {
    if (searchText.length >= 3) {
      onSearch(searchText);
      setShowClearButton(true);
    }
  };

  const handleClear = () => {
    setSearchText("");
    setShowClearButton(false);
    onSearch(undefined);
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchText(value);

    if (value.length < 4 && showClearButton) {
      setShowClearButton(false);
    }
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const isSearchButtonVisible = searchText.length >= 4;

  return (
    <TextField
      placeholder="Search for anything"
      sx={{ width: "100%" }}
      value={searchText}
      onChange={handleInputChange}
      onKeyDown={handleKeyDown}
      style={{ height: 40 }}
      slotProps={{
        input: {
          style: { height: 40 },
          startAdornment: (
            <InputAdornment position="start">
              <Iconify icon="iconamoon:search" />
            </InputAdornment>
          ),
          endAdornment: (
            <>
              {isSearchButtonVisible && !showClearButton && (
                <InputAdornment position="end">
                  <Button
                    onClick={handleSearch}
                    sx={{
                      color: "grey.500",
                    }}
                  >
                    Search
                  </Button>
                </InputAdornment>
              )}
              {showClearButton && (
                <InputAdornment position="end">
                  <IconButton onClick={handleClear}>
                    <Iconify icon="uil:times-circle" />
                  </IconButton>
                </InputAdornment>
              )}
            </>
          ),
        }
      }}
    />
  );
};
